import { useSession } from "providers/SessionProvider";
import React from "react";
import { useNavigate } from "react-router";
import { EditUserTopics } from "views/foundation/user/Home/EditUser/EditUserTopics";
////////////////////////////////////////////////////////////////////////////

/**
 * Perfil de Usuário - Interesses do usuário
 * @param props
 */
export const EditUserProfileInterest: React.FC = () => {

    const { user } = useSession();
    const navigate = useNavigate();

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <EditUserTopics userId={user.userId} userName={user.name} editMode="profile" onClose={() => navigate(-1)} />
    );
};
